import { atom } from 'recoil'
import { Annotation } from 'types/building'

type POVValue = { h: number; v: number; z: number }

type Props = POVValue | null

export const currentPovState = atom<Props>({
  key: 'currentPov',
  default: null
})

export const povPerPointState = atom<Record<string, POVValue>>({
  key: 'povPerPoint',
  default: {}
})

export const currentAnnotation = atom<
  (Annotation & { isMutating?: boolean }) | undefined
>({
  key: 'currentAnnotation',
  default: undefined
})
